import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import AddWysiwygBlockButton from './AddWysiwygBlockButton';
import AddIFrameBlockButton from './AddIFrameBlockButton';
import AddExerciseBlockButton from './AddExerciseBlockButton';
import AddVideoBlockButton from './AddVideoBlockButton';
import { useParams } from 'react-router';
import { UrlParams } from '../../../../shared/types';
import { GroupTitle, GroupWrapper, StyledGroup } from './Atoms';
import AddColumnBlockButton from './AddColumnBlock';
import AddClusterBlockButton from './AddClusterBlockButton';
import AddSectionBlockButton from './AddSectionBlockButton';

export type AddBlockButtonGroupProps = {
  pageId: string;
  previousBlockId?: string;
  showOnHover?: boolean;
  clusterId?: string;
  sectionId?: string;
};

const AddBlockButtonGroup: FC<AddBlockButtonGroupProps> = ({
  pageId,
  previousBlockId,
  clusterId,
  showOnHover,
  sectionId,
}) => {
  const { t } = useTranslation();
  const { bookId } = useParams<UrlParams>();

  return (
    <GroupWrapper className={`hide-on-print ${showOnHover ? 'show-on-hover' : ''}`}>
      <GroupTitle>{t('trajectory.sidebar.pageManagement.addBlock')}</GroupTitle>
      <StyledGroup>
        <AddWysiwygBlockButton
          viewMode="sidebar"
          pageId={pageId}
          bookId={bookId!!}
          previousBlockId={previousBlockId}
          clusterId={clusterId}
          sectionId={sectionId}
        />
        <AddIFrameBlockButton
          viewMode="sidebar"
          pageId={pageId}
          bookId={bookId!!}
          previousBlockId={previousBlockId}
          clusterId={clusterId}
          sectionId={sectionId}
        />
        <AddVideoBlockButton
          viewMode="sidebar"
          pageId={pageId}
          bookId={bookId!!}
          previousBlockId={previousBlockId}
          clusterId={clusterId}
          sectionId={sectionId}
        />
        <AddExerciseBlockButton
          viewMode="sidebar"
          pageId={pageId}
          bookId={bookId!!}
          previousBlockId={previousBlockId}
          clusterId={clusterId}
          sectionId={sectionId}
        />
        <AddColumnBlockButton
          viewMode="sidebar"
          pageId={pageId}
          bookId={bookId!!}
          previousBlockId={previousBlockId}
          clusterId={clusterId}
          sectionId={sectionId}
        />
        {(previousBlockId !== sectionId || !clusterId) && (
          <AddClusterBlockButton
            viewMode="sidebar"
            pageId={pageId}
            bookId={bookId!!}
            previousBlockId={previousBlockId}
            clusterId={clusterId}
            sectionId={sectionId}
          />
        )}
        {clusterId && previousBlockId !== sectionId && (
          <>
            <AddSectionBlockButton
              viewMode="sidebar"
              pageId={pageId}
              bookId={bookId!!}
              previousBlockId={previousBlockId}
              clusterId={clusterId}
              sectionId={sectionId}
            />
          </>
        )}
      </StyledGroup>
    </GroupWrapper>
  );
};

export default AddBlockButtonGroup;
